import { useQuery, type QueryClient } from "@tanstack/react-query";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import type { Usuario } from "@/ts/typings/clases";
import { TablaPersonalCiclo } from "./TablaPersonalCiclo";

interface ModalSeleccionarPersonalProps extends BaseModalProps { readonly idCiclo: number | null; }
export function ModalSeleccionarPersonal(props: ModalSeleccionarPersonalProps) {
	return (
		<BaseModal show={props.show} close={props.close}>
			<div className="modal-header">
				<h4 className="modal-title">Personal</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body" style={{ minWidth: "50vw" }}>
				<div className="content-box big-box">
					<div className="table-responsive">
						<TablaPersonalCiclo idCiclo={props.idCiclo} />
					</div>
				</div>
				<div className="modal-footer">
					<button type="button" className="btnSecondary" onClick={props.close}>Cerrar</button>
				</div>
			</div>
		</BaseModal>
	);
}

interface PersonalAsignadoParams {
	idCiclo: number | null;
}
export function usePersonalAsignado(params: PersonalAsignadoParams) {
	return useQuery<UsuarioAsignado[]>({
		queryKey: ["getPersonalAsignado", params],
		queryFn: () => {
			if (params.idCiclo == null) return Promise.resolve([]);
			return sendAjaxRequest<UsuarioAsignado[]>("GET", "/api/v1/getPersonalAsignado", params);
		},
	});
}
export interface UsuarioAsignado {
	ciclo_id: number | null;
	medio_id: number | null;
	pedido_id: number | null;
	representante_id: number;
}
export function useUsuriosDisponibles() {
	return useQuery<Usuario[]>({
		queryKey: ["getCarretillerosAlmacen"],
		queryFn: () => sendAjaxRequest<Usuario[]>("GET", "/api/v1/getCarretillerosAlmacen", []),
	});
}




export async function asignarCicloUsuario(idCiclo: number, idRepresentante: number, queryClient: QueryClient): Promise<void> {
	const parametro = {
		"idCiclo": idCiclo,
		"idRepresentante": idRepresentante,
	};

	const url = "/api/v1/asignarCicloUsuario";

	await sendAjaxRequest("POST", url, parametro);
	const prevData = queryClient.getQueryData<UsuarioAsignado[]>(["getPersonalAsignado", { idCiclo }]);
	if (prevData) {
		const newData = [...prevData, { ciclo_id: idCiclo, medio_id: null, pedido_id: null, representante_id: idRepresentante }];
		queryClient.setQueryData(["getPersonalAsignado", { idCiclo }], newData);
	} else {	//Si podemos usar los datos previos, los actualizamos en cache sin necesidad de recargar, que es una peticion pesada
		await queryClient.invalidateQueries({ queryKey: ["getPersonalAsignado", { idCiclo }] });
	}
	await queryClient.invalidateQueries({ queryKey: ["getCiclosAsignados"] });
}
export async function eliminarCicloUsuario(idCiclo: number, idRepresentante: number, queryClient: QueryClient): Promise<void> {
	const parametro = {
		"idCiclo": idCiclo,
		"idRepresentante": idRepresentante,
	};

	const url = "/api/v1/eliminarCicloUsuario";

	await sendAjaxRequest("POST", url, parametro);

	const prevData = queryClient.getQueryData<UsuarioAsignado[]>(["getPersonalAsignado", { idCiclo }]);
	if (prevData) {
		const newData = prevData.filter(item => item.representante_id != idRepresentante);
		queryClient.setQueryData(["getPersonalAsignado", { idCiclo }], newData);
	} else {	//Si podemos usar los datos previos, los actualizamos en cache sin necesidad de recargar, que es una peticion pesada
		await queryClient.invalidateQueries({ queryKey: ["getPersonalAsignado", { idCiclo }] });
	}
	await queryClient.invalidateQueries({ queryKey: ["getCiclosAsignados"] });
}